import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-el-marker',
    template: `<span [class]="(size === 'lg' ? 'marker--lg ' : '')+'marker ' + getPriority()"> {{getPriority()}} </span>`
})

export class ElMarkerComponent {
    @Input() label: any;
    @Input() priority:any;
    @Input() size: 'sm' | 'lg' = 'sm';

    public getPriority() {
        const pr:any = {
            '1': 'low',
            '0': 'mod',
            '-1': 'hgh'
        };
        return pr[this.priority];
    }
}
